import React, { useState } from "react";
import { Icon } from "@iconify/react";
import style from "./CustomerTxList.module.css";

export default function CustomerTxTable({
  columns,
  allCategories,
  handleEditData,
  handlePrint,
  title,
  searchInput,
  setSearchInput,
  usedFor = "",
  showActionButton = true,
  showSum = false,
  sum = {},
}) {
  const thStyle = {
    padding: "5px",
    border: "1px solid #ccc",
    textAlign: "center",
    backgroundColor: "#627383",
    color: "#fff",
    fontSize: "12px",
    fontWeight: "500",
    // minWidth: "fit-content",
  };

  const tdStyle = {
    fontSize: "12px",
    padding: "5px",
    border: "1px solid #ccc",
    textAlign: "center",
  };

  const [rowsPerPages, setRowsPerPages] = useState(25); // Default rows per page
  const [currentPage, setCurrentPage] = useState(1);

  const filteredData = searchInput
    ? allCategories?.filter((item) =>
        Object.values(item)?.some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(searchInput.toLowerCase())
        )
      )
    : allCategories;

  const totalPages = Math.ceil(filteredData?.length / rowsPerPages);
  const startIndex = (currentPage - 1) * rowsPerPages;
  const displayedData = filteredData?.slice(
    startIndex,
    startIndex + rowsPerPages
  );

  const preprocessedData = displayedData?.map((product, idx) => ({
    ...product,
    Id: product.Id !== undefined ? product.Id : `temp-id-${idx}`,
    serialNumber: startIndex + idx + 1, // Serial number
  }));

  const handlePageClick = (page) => {
    if (page <= totalPages && page >= 1) setCurrentPage(page);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPages(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  // Smart Pagination Logic
  const generatePagination = () => {
    let pages = [];
    let maxPagesToShow = 0;

    if (totalPages <= maxPagesToShow) {
      pages = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      pages.push(1);

      if (currentPage > 5) {
        pages.push("...");
      }

      let start = Math.max(2, currentPage - 1);
      let end = Math.min(totalPages - 1, currentPage + 1);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 2) {
        pages.push("...");
      }

      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <>
      <div className={style["table-container"]}>
        <table className={style["custom-table"]}>
          <thead style={{ backgroundColor: "#627383", color: "#FFFFFF" }}>
            <tr>
              {columns?.map((column) => (
                <th key={column.key} style={thStyle}>
                  {column.label}
                </th>
              ))}
              {showActionButton ? <th style={thStyle}>Action</th> : ""}
            </tr>
          </thead>
          <tbody>
            {preprocessedData?.length ? (
              preprocessedData.map((product, idx) => (
                <tr
                  key={product.Id}
                  className={idx % 2 === 0 ? style.evenRow : style.oddRow}
                >
                  {console.log(columns)}
                  {columns?.map((column) => (
                    <td key={column.key} style={tdStyle}>
                      {column?.key == "PlaneWeightByCategories" ? (
                        <div
                          className="weight-group"
                          style={{ marginRight: "2px" }}
                        >
                          {product?.StoneCategories?.split(",").map(
                            (item, Iindex) => (
                              <>
                                <div className="weight-boxL">{`${item} GM`}</div>
                                <div className="weight-boxR">
                                  {product.StonePieces.split(",")[Iindex]}
                                </div>
                              </>
                            )
                          )}
                        </div>
                      ) : (
                        <>
                          {column.type === "read"
                            ? column.calculate
                              ? column.calculate(product)
                              : column.label === "Customer"
                              ? `${product?.FirstName}`
                              : column.label === "Full Stone Less"
                              ? `${
                                  product[column.key] === "true" ? "YES" : "NO"
                                }`
                              : product[column.key]
                            : ""}
                        </>
                      )}
                    </td>
                  ))}
                  {showActionButton ? (
                    <td style={tdStyle}>
                      <div className={style["action-container"]}>
                        <Icon
                          onClick={() => handleEditData(product)}
                          style={{ color: "#627282", cursor: "pointer" }}
                          icon="material-symbols-light:edit-outline"
                          width="20"
                          height="20"
                        />
                        {usedFor !== "rates" && (
                          <Icon
                            style={{ color: "#627282", cursor: "pointer" }}
                            icon="weui:delete-filled"
                            width="20"
                            height="20"
                          />
                        )}
                        <Icon
                          onClick={() => handlePrint(product)}
                          style={{ color: "#627282", cursor: "pointer" }}
                          icon="ic:outline-print"
                          width="20"
                          height="20"
                        />
                      </div>
                    </td>
                  ) : (
                    ""
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns?.length + 1} className={style?.tableCell}>
                  No Data
                </td>
              </tr>
            )}
          </tbody>
          {showSum && (
            <tfoot>
              {columns?.map((column) => (
                <th key={column.key} style={thStyle}>
                  {sum[column?.key]}
                </th>
              ))}
            </tfoot>
          )}
        </table>
      </div>

      {/* Pagination */}
      {allCategories?.length ? (
        <div
          className={style["page-controls"]}
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            fontSize: "8px",
          }}
        >
          <div className={style["rows-per-page"]}>
            <label htmlFor="rows-per-page">Rows per page</label>
            <select
              id="rows-per-page"
              value={rowsPerPages}
              onChange={handleRowsPerPageChange}
            >
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>
          <div className={style["pagination"]}>
            <button
              disabled={currentPage === 1}
              onClick={() => handlePageClick(currentPage - 1)}
            >
              Prev
            </button>

            {generatePagination().map((page, index) =>
              page === "..." ? (
                <span key={index} className={style.dots}>
                  ...
                </span>
              ) : (
                <button
                  key={index}
                  className={
                    currentPage === page
                      ? style["pagination-pages-active"]
                      : style["pagination-pages"]
                  }
                  onClick={() => handlePageClick(page)}
                >
                  {page}
                </button>
              )
            )}

            <button
              disabled={currentPage === totalPages}
              onClick={() => handlePageClick(currentPage + 1)}
            >
              Next
            </button>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}
